import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import BoxTile from "@components/Global/Custom/BoxTile";
import useStaticContext from "@hooks/useStaticContext";

const RecommendedTiles = () => {
	const { services } = useStaticContext();
	return (
		<Box component="main" flexGrow={1} p={4} mb={12}>
			<Container maxWidth={"md"}>
				<Box mt={6} mb={8}>
					<Box fontWeight={600} fontSize={22}>
						Recommended for you
					</Box>
				</Box>

				<Grid container spacing={4}>
					{(services || []).map((service) => (
						<BoxTile
							key={service.key}
							title={service.name_proper || service.phrase || service.name}
							src={service.image_url}
							link={`${service.url}`}
						/>
					))}
				</Grid>
			</Container>
		</Box>
	);
};

RecommendedTiles.propTypes = {};
export default RecommendedTiles;
